import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchChargeInsert } from '@/api/PMS/houseDeliveryManage/decorationRegistration';
import { fetchListByType } from '@/api/PMS/dic/dic';
export default {
  props: {
    showDialog: Boolean,
    confirmData: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      activeName: 'first',
      loading: false,
      list: [],
      tableData: [],
      multipleSelection: [],
      options: [],
      paymentOptions: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
    this.loadPaymentOptions();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();

        _this.confirmData.billAndStandardListVos.forEach(function (item1) {
          item1.paymentMethod = _this.confirmData.chargeTypeList[0].paymentMethodName;
          item1.receiptDate = _this.confirmData.receiptDate;
          item1.totalAmount = 0;
          item1.decorateStandardInfoVos.forEach(function (item2) {
            item1.totalAmount += item2.amount;
          });
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    loadPaymentOptions: function loadPaymentOptions() {
      var _this2 = this;

      fetchListByType('building_type').then(function (r) {
        _this2.paymentOptions = r.data.data;
      });
    },
    handUpdate: function handUpdate() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          // const confirmQuery = this.confirmData.decorateStandardInfoVos.map(item => {
          //   return {
          //     decorateId: this.confirmData.decorateId,
          //     chargeItemId: item.chargeItemId,
          //     chargeTypeId: item.chargeTypeId,
          //     beginDate: this.confirmData.beginDate,
          //     endDate: this.confirmData.endDate,
          //     amount: this.confirmData.amount
          //   }
          // })
          var confirmParam = JSON.parse(JSON.stringify(_this3.confirmData));
          delete confirmParam.chargeTypeList;
          delete confirmParam.billAndStandardListVos;
          delete confirmParam.paymentMethodName;
          fetchChargeInsert(confirmParam).then(function () {
            _this3.$emit('handCancle', 'confirm');

            _this3.Alert({
              alertType: 'update',
              message: '收费成功'
            });
          });
        } else {
          _this3.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handleCancle: function handleCancle() {
      this.$emit('handCancle');
    }
  }
};